export type AttachStatus = 'pending' | 'review' | 'accepted' | 'read';

export const STATUS_PALETTE: Record<
	AttachStatus,
	{ label: string; cls: string }
> = {
	pending: { label: 'В работе', cls: 'text-green-700' },
	review: { label: 'На проверке', cls: 'text-yellow' },
	accepted: { label: 'Решена', cls: 'text-gray-3' },
	read: { label: 'Прочитано', cls: 'text-gray-3' },
};
